import React, { useState, useEffect } from 'react';

import { Card } from 'antd';

import styled from 'styled-components';

import { useProjectContext, useProjectContextDispatch } from '@contexts/ProjectContext';
import { useStateValue } from '@contexts/StateProvider';

import { forceReloadProject } from '@hooks/API/Project/UseProject';

import EventDrawer from '@components/EventDrawer/EventDrawer';
import EmptyState from '@components/Gui/EmptyState';
import FlexContainer from '@components/Gui/FlexContainer';
import { Loading } from '@components/Gui/Loading';
import { NwAddButton } from '@components/Gui/NwButton';
import { NwCard, NwCardContent } from '@components/Gui/NwCard/NwCard';
import TaskCard from '@components/TaskList/TaskCard';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const Container = styled.div`
    .ant-card-body-content {
        padding: 0 !important;
    }

    .ant-card-grid {
        float: left; //added because ant removed it to use flex- to update later
        height: 270px;
        padding: 0;
        width: 50%;
        @media only screen and (max-width: 768px) {
            width: 100%;
        }
        @media only screen and (max-width: 600px) {
            width: 100%;
        }
    }

    .nw-card-paginated-content {
        padding: 0 !important;
    }
    .ant-row-space-between {
        flex-direction: row-reverse;
    }
`;

const ProjectTodos = () => {
    const { projectId, projectData: currentProject } = useProjectContext();
    const projectDispatch = useProjectContextDispatch();
    const [addDrawer, setAddDrawer] = useState(false);
    const [{ areaContext }] = useStateValue();

    const isFetching = false;

    const [projectTasks, setProjectTasks] = useState([]);

    useEffect(() => {
        if (!isFetching && currentProject) {
            //const te = onGetOrderedEventList(currentProject, areaContext, false, false)
            //setProjectEvents(te)

            const tds = currentProject.ToDos.filter((todo) => {
                if (
                    todo.Visibility.Areas.length === 0 ||
                    todo.Visibility.Areas.find((area) => area === areaContext.area)
                ) {
                    return true;
                }
                return false;
            });
            setProjectTasks(tds);
        }

    }, [currentProject, isFetching]);

    const handleOpenAddTodoDialog = () => {
        setAddDrawer(true);
    };

    const handleCloseAddDrawer = () => {
        setAddDrawer(false);
    };

    const onReloadTodos = async () => {
        const updatedProject = await forceReloadProject(projectId);
        projectDispatch({ type: 'UpdateProjectData', projectData: updatedProject });
    };

    // const renderTodos = () => {
    //     if (!projectTasks || !projectTasks.length) return (null);
    //     let filteredTasks = projectTasks;
    //     filteredTasks.sort((a, b) => {
    //         if (a.GlobalStatus === b.GlobalStatus) return 0;
    //         if (a.GlobalStatus === "Completed") return 1;
    //         if (b.GlobalStatus === "Completed") return -1;
    //         if (a.GlobalStatus === "PartiallyCompleted") return 1;
    //         return -1;
    //     });
    //     return (
    //         <Row className="content" wrap={true}>
    //             {filteredTasks.length > 0 && filteredTasks.map((todo, index) => {
    //                 return (
    //                     <Col className='todo-item' key={index} lg={8} md={12} sm={24} xs={24}>
    //                         <TodoItem
    //                             showAll={true}
    //                             todoItem={todo}
    //                             todoType={'public'}
    //                             projectId={projectId}
    //                             onUpdate={onReloadTodos} />
    //                     </Col>
    //                 );
    //             })}
    //         </Row>
    //     );
    // }

    return (
        <Container>
            {isFetching ? (
                <Loading />
            ) : (
                <NwCard
                    title="Tasks"
                    icon={byPrefixAndName.fasl['tasks']}
                    extra={
                        <FlexContainer>
                            <NwAddButton ghost size="small" label="new task" onClick={handleOpenAddTodoDialog} />
                        </FlexContainer>
                    }
                >
                    <NwCardContent
                    // pagination={{ total: todosList.length, current: activePage, pageSize: itemsPerPage, onChange: (page) => setActivePage(page), showSizeChanger: false }}
                    >
                        <div>
                            {projectTasks &&
                                projectTasks
                                    .sort((a, b) => {
                                        if (a.GlobalStatus === b.GlobalStatus) return 0;
                                        if (a.GlobalStatus === 'Completed') return 1;
                                        if (b.GlobalStatus === 'Completed') return -1;
                                        if (a.GlobalStatus === 'PartiallyCompleted') return 1;
                                        return -1;
                                    })
                                    .map((todo, index) => {
                                        return (
                                            <Card.Grid key={index}>
                                                <TaskCard
                                                    showAll={true}
                                                    todoItem={todo}
                                                    todoType={'public'}
                                                    projectId={projectId}
                                                    onUpdate={onReloadTodos}
                                                />
                                            </Card.Grid>
                                        );
                                    })}
                            {(!projectTasks || !projectTasks.length) && <EmptyState message="No data" />}
                        </div>
                    </NwCardContent>
                </NwCard>
            )}
            {addDrawer && (
                <EventDrawer
                    viewMode="create"
                    onClose={handleCloseAddDrawer}
                    afterUpdate={onReloadTodos}
                    eventType="todo"
                    projectId={projectId}
                />
            )}
        </Container>
    );
};

export default ProjectTodos;
